import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";

import { Provider, connect } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import {
  select,
  call,
  put,
  takeEvery,
  takeLatest,
  delay,
  all,
} from "redux-saga/effects";

import reducer from "./botcomponent/reducer";
import MySaga from "./botcomponent/sagafunc";

import { changetitle } from "./commonfunc/common";

interface BotState {
  baseJson: any; // 表示に使うページ
  CurrentPages: number; // 現在のページ
  PageMaxPost: number; // １ページあたりの表示数
  DateOrigin: any; // 日付
  Ids: any;
}

/**
 *
 */
const fgetURL = () => {
  const url = document.getElementById("fetchUrl");
  //console.log("url is ",url.innerText);
  return url.innerText;
};
const fget_date_origin = () => {
  const dateorigin = document.getElementById("date_origin");
  //console.log("url is ",url.innerText);
  return dateorigin.innerText;
};
/**
 *
 */
const fgetPages = () => {
  const pages = document.getElementById("pages");
  //console.log("url is ",url.innerText);
  return Number(pages.innerText);
};
/**
 *
 */
const fgetID = () => {
  const ids = document.getElementById("ids");
  //console.log("url is ",url.innerText);
  return ids.innerText;
};

/**
 *
 */
class ListApp extends React.Component<any, BotState> {
  state: BotState = {
    baseJson: [],
    CurrentPages: fgetPages(),
    PageMaxPost: 100,
    DateOrigin: fget_date_origin(),
    Ids: fgetID(),
  };
  componentWillMount = () => {};
  componentWillUnmount = () => {};
  componentDidMount() {
    // initialize saga
    this.props.dispatch({ type: "Ajax_Get_Post", url: fgetURL() });
  }
  componentWillReceiveProps() {}

  /**
   *
   *
   * render
   *
   *
   */
  public render() {
    //console.log("baseJson is ", this.props.baseJson);
    if (this.props.baseJson.count != 0) {
      //const start = this.state.CurrentPages * this.state.PageMaxPost;
      ///const goal = (this.state.CurrentPages + 1) * this.state.PageMaxPost;

      //console.log("start is",start);
      //console.log("goal is",goal);

      //const baseJson = this.props.baseJson.data.slice(start, goal);
      const baseJson = this.props.baseJson.data;
      //console.log(baseJson);

      //const ItemList = this.props.baseJson.data.map((v: any, i: any) => {
      const ItemList = baseJson.map((v: any, i: any) => {
        if (v.id == this.state.Ids) {
          //seo
          document.title = changetitle(v.title) + " 販売・買取";
          const ref_links =
            "/list/index.php?date=" +
            v.date +
            "&pages=" +
            (this.state.CurrentPages + 1);

          return (
            <div key={i} id="AuctionDetail">
              <h2 className="title">{changetitle(v.title)}</h2>

              <div className="itemnumbers">管理ID: {v.id} </div>

              <div className="column">
                <img alt={changetitle(v.title)} src={v.main_image} />
              </div>

              <div className="columns">
                <div className="column is-6">
                  <div className="values">
                    <p>
                      こちらの商品は
                      {v.date} に落札された商品です。 「　{changetitle(v.title)}
                      　」として出品されました。
                    </p>
                    <p>
                      入札数は「{v.bits}」で、落札金額は「{v.price} 円
                      」でした。
                      <br />
                      商品ランクは「{v.rank}」です。
                    </p>
                    <p>
                      <span className="def2">
                        ※上記商品の販売は終了しております。 現在販売中の商品は
                        <a
                          className="check"
                          href="https://auctions.yahoo.co.jp/seller/toys_h1"
                          target="_blakn"
                        >
                          ＞コチラ
                        </a>
                        　をご参照ください。{" "}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="column is-6">
                  <div className="tag is-primary">落札日</div>
                  <div className="values">{v.date} </div>
                </div>

                <div className="column is-6">
                  <div className="tag is-primary">　落札金額　</div>
                  <div className="values">{v.price} 円</div>
                </div>

                <div className="column is-6">
                  <div className="tag is-primary">　ランク　</div>
                  <div className="values">{v.rank}</div>
                </div>
              </div>

              <div className="columns is-12" style={{ overflow: "scroll" }}>
                <ul style={{ display: "flex" }}>
                  {v.images.map((vv: any, ii: number) => (
                    <li key={ii} style={{ flexBasis: "20%" }}>
                      <img
                        alt={changetitle(v.title) + "-" + ii}
                        src={vv}
                        style={{ width: "200px" }}
                      />
                    </li>
                  ))}
                </ul>
              </div>

              <div className="columns is-6">
                <div className="column is-12" id="categories">
                  {v.categories}
                </div>
              </div>

              <div className="columns is-6">
                <div className="values">
                  <div className="tag is-primary">関連 リストページ</div>

                  <a className="check2" href={ref_links}>
                    {v.date} 付 リスト一覧
                  </a>
                </div>
              </div>
            </div>
          );
        } else {
          return null;
        }
      });

      /** page list */
      const PagingAll = Math.ceil(
        this.props.baseJson.count / this.state.PageMaxPost
      );

      /** */

      return <div>{ItemList}</div>;
    } else {
      return <p>now loading</p>;
    }
  }
}

/**
 * 1-3 set App
 */
const App: any = (() => {
  const mapStatetoProps = (state: any) => {
    return { ...state };
  };
  return connect(mapStatetoProps)(ListApp);
})();

/**
 * 3-4 sagaMiddleware
 */
const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(MySaga);

ReactDOM.render(
  <div>
    <Provider store={store}>
      <App />
    </Provider>
  </div>,
  document.getElementById("app")
);
